/**
 * Breakpoint Constants
 *
 * Defines responsive breakpoint thresholds matching Tailwind CSS configuration.
 * Used by useBreakpoint and useMediaQuery hooks for JavaScript-based
 * responsive logic when CSS-only solutions are insufficient.
 *
 * @see https://tailwindcss.com/docs/responsive-design
 */

/**
 * Breakpoint pixel thresholds
 * - mobile: 0-639px
 * - tablet: 640-1023px (Tailwind 'sm' breakpoint and up)
 * - desktop: 1024px+ (Tailwind 'lg' breakpoint and up)
 */
export const BREAKPOINTS = {
  mobile: 0,
  tablet: 640,
  desktop: 1024,
} as const;

/**
 * Breakpoint identifier type
 */
export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

/**
 * CSS media query strings for each breakpoint range
 * These can be used directly with window.matchMedia() or useMediaQuery hook
 */
export const MEDIA_QUERIES = {
  /** Matches mobile: viewport width < 640px */
  mobile: '(max-width: 639px)',
  /** Matches tablet: 640px <= viewport width < 1024px */
  tablet: '(min-width: 640px) and (max-width: 1023px)',
  /** Matches desktop: viewport width >= 1024px */
  desktop: '(min-width: 1024px)',
  /** Matches tablet or desktop: viewport width >= 640px */
  notMobile: '(min-width: 640px)',
} as const;

/**
 * Type for media query keys
 */
export type MediaQueryKey = keyof typeof MEDIA_QUERIES;
